import {getConfigValue} from '../../../util/runs';
import {KeyVal} from '../../../util/runTypes';

export const getSupplementalMetrics = (
  metricKeys: string[],
  metrics: {
    configMetrics: KeyVal;
    summaryMetrics: Record<string, unknown>;
  }
) => {
  const supplementalMetrics = metricKeys.reduce((acc, metric) => {
    if (metric.startsWith('config:')) {
      const configValue = getConfigValue(
        metrics.configMetrics,
        metric.split(':')[1]
      );
      // only add numeric config values
      if (configValue != null && typeof configValue === 'number') {
        acc[metric] = configValue;
      }
    }

    if (metric.startsWith('summary:')) {
      const m = metric.split(':').slice(1).join(':');
      if (m in metrics.summaryMetrics) {
        acc[metric] = metrics.summaryMetrics[m] as unknown as number;
      }
    }

    return acc;
  }, {} as Record<string, number>);

  return supplementalMetrics;
};
